import { tagSplitLength } from "./tag-split-length";

type SliceByTagNumberArgs = {
  /** 分割対象の配列 */
  array: number[];
  /** 対象の配列をどれだけ分割するか */
  splitNumber: number;
};

/** 特定の配列を指定した数だけ分割する処理 */
export const sliceByTagNumber = (args: SliceByTagNumberArgs) => {
  const { array, splitNumber } = args;

  // MEMO（kimura）: 数字を0で割ることはできないため早期return または 配列の要素数が20以下の場合は早期return
  if (splitNumber === 0 || array.length <= 20) return [];

  const tagSplitResultLength = tagSplitLength(array.length, splitNumber);
  const rest = array.length % splitNumber;

  return [...Array(tagSplitResultLength)].map((_, idx) => {
    const restNum = idx === tagSplitResultLength - 1 ? rest : 0;
    return array.slice(idx * splitNumber, (idx + 1) * splitNumber + restNum);
  });
};
